export const WORKSHOP_MODULE = 'WORKSHOP_MODULE';

export const WORKSHOP = 'WORKSHOP';
export const VIEW_WORKSHOP = 'VIEW_WORKSHOP';
